import { PriceMatrixType } from '../../views/products/ProductTypes';

// Resolves the price of a size from a width x depth price matrix, the size
// is rounded up to the first matrix width and depth which fit. Returns null
// when the size is bigger than the matrix or the matching cell has no price
export const resolveMatrixPrice = (matrix: PriceMatrixType | null | undefined, width: number | null, depth: number | null): number | null => {
    // Nothing to resolve without a matrix or a complete size
    if (!matrix || width === null || depth === null || isNaN(width) || isNaN(depth)) return null;

    // Find the first matrix width and depth which fit the given size
    const widthIndex = matrix.widths.findIndex(matrixWidth => matrixWidth >= width);
    const depthIndex = matrix.depths.findIndex(matrixDepth => matrixDepth >= depth);
    if (widthIndex === -1 || depthIndex === -1) return null;

    // Return the price of the matching cell
    const price = matrix.prices[depthIndex]?.[widthIndex];
    return price === undefined || price === null ? null : price;
};

// Parses a dimension input into a whole number of centimeters, empty input gives null
export const parseDimensionInput = (value: string): number | null => {
    const digits = value.replace(/[^0-9]/g, '');
    if (digits === '') return null;
    return parseInt(digits, 10);
};
